import * as React from "react";
import {
  Box,
  Divider,
  Typography,
  TextField,
  FormControl,
  FormLabel,
  Button,
} from "@mui/material";
import dayjs from "dayjs";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { styled, useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import { showMessage } from "../store/messageSlice";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import CustomTextField from "../common/CustomTextField";
import LocationsMenu from "../common/locationsMenu";
import MultiSelect from "../common/multiSelect";
import UsersMenu from "../common/usersMenu";
import StateHistoryTypeMenu from "../common/stateHistoryTypeMenu";

import AlertDialog from "../common/AlertDialog";
import { setStateHistory } from "../store/stateHistorySlice";
import { getUrlVars } from "../utils/systemInfo";
import DevicesService from "../api/devices";

const initialState = {
  device_state_history_id: "",
  serial: "Unplanned",
  state_type: "",
  state_result: "",
  state_description: "",
  state_start: "",
  state_end: "",
  state_location_id: "",
  assigned_to_person_id: "",
  device_state_history_tags: [],
  status: "active",
};
const StyledButton = styled((props) => <Button {...props} />)(({ theme }) => ({
  backgroundColor: theme.palette.custom.buttonColor,
  color: theme.palette.custom.buttonTextColor,
  "&:hover": {
    backgroundColor: theme.palette.custom.buttonHoverColor,
    color: theme.palette.custom.buttonHoverTextColor,
    boxShadow: "none",
  },
  "&:disabled": {
    opacity: 0.6,
  },
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));
const StyledDateTimePicker = styled(DateTimePicker)(({ theme }) => ({
  height: "36px",
  backgroundColor: theme.palette.custom.buttonColor,
  color: theme.palette.custom.buttonTextColor,
  margin: "0px 8px",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: theme.palette.custom.buttonHoverColor,
    color: theme.palette.custom.buttonHoverTextColor,
  },
  "& .MuiButtonBase-root": {
    height: "30px",
    color: theme.palette.custom.buttonTextColor,
    // backgroundColor: theme.palette.custom.buttonColor,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: theme.palette.custom.borderColor,
      borderRadius: "4px",
    },
    height: "36px",
    color: theme.palette.custom.buttonTextColor,
  },
  "& .MuiInputLabel-root": {
    color: theme.palette.custom.text,
  },
}));
function AddEditDeviceStateHistory({
  triggerToggleDrawer,
  refreshStateHistory,
  usersList,
  locationsList,
  tagsList,
}) {
  const { t } = useTranslation();
  const theme = useTheme();
  const [type, setType] = useState("Unplanned");
  const [result, setResult] = useState("");
  const [description, setDescription] = useState("");
  const [locationId, setlocationId] = useState("");
  const [userId, setUserId] = useState("");
  const [fromValue, setFromValue] = useState(dayjs(new Date()));
  const [toValue, setToValue] = useState(null);
  const [savingLoading, setSavingLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openSaveDialog, setOpenSaveDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [clearLoading, setClearLoading] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);

  const dispatch = useDispatch();
  const timezoneMins = useSelector(({ timezone }) => timezone);
  const stateHistory = useSelector(({ stateHistory }) => stateHistory);
  const deviceSerial = String(getUrlVars()["serial"]);
  const organziation = useSelector(({ organziation }) => organziation);

  useEffect(() => {
    console.log("deviceStateHistory", stateHistory);
    setType(stateHistory.state_type);
    setResult(stateHistory.state_result);
    setDescription(stateHistory.state_description);
    setlocationId(stateHistory.state_location_id);
    setUserId(stateHistory.assigned_to_person_id);
    const oldTagsArray = [];
    stateHistory.device_state_history_tags.map((value) => {
      oldTagsArray.push({
        id: value.device_state_tag_id,
        name: value.tag_name,
      });
    });
    setSelectedTags(oldTagsArray);
    setUserId(stateHistory.assigned_to_person_id);
    setFromValue(
      stateHistory.state_start
        ? dayjs(stateHistory.state_start).add(timezoneMins, "minutes")
        : dayjs(new Date())
    );
    setToValue(
      stateHistory.state_end
        ? dayjs(stateHistory.state_end).add(timezoneMins, "minutes")
        : null
    );

    // if (stateHistory?.device_state_history_id !== "") {
    //   setType(stateHistory.state_type);
    //   setResult(stateHistory.state_result);
    //   setDescription(stateHistory.state_description);
    //   setFromValue(
    //     dayjs(stateHistory.state_start).add(timezoneMins, "minutes")
    //   );
    //   setToValue(dayjs(stateHistory.state_end).add(timezoneMins, "minutes"));
    // }
    //  else {
    //   dispatch(setStateHistory(initialState));
    // }

    // return () => {
    //   dispatch(setTag(initialState));
    // };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateHistory]);
  function canBeSubmitted() {
    return type;
  }
  function handleSave() {
    setSavingLoading(true);
    const apiKey =
      organziation?.api_key_list?.[0]?.key ?? localStorage.getItem("apiKey");
    const tagsArrayToAdd = [];
    if (stateHistory.device_state_history_tags.length > 0) {
      selectedTags.map((value) => {
        const tagIndex = stateHistory.device_state_history_tags
          .map((e) => e.device_state_tag_id)
          .indexOf(value.id);
        if (tagIndex === -1) {
          tagsArrayToAdd.push({
            device_state_tag_id: value.id,
            action: "link",
          });
        }
      });
      stateHistory.device_state_history_tags.map((value) => {
        const tagIndex = selectedTags
          .map((e) => e.id)
          .indexOf(value.device_state_tag_id);
        if (tagIndex === -1) {
          tagsArrayToAdd.push({
            device_state_tag_id: value.device_state_tag_id,
            action: "unlink",
          });
        }
      });
    } else {
      if (selectedTags.length > 0) {
        selectedTags.map((value) => {
          tagsArrayToAdd.push({
            device_state_tag_id: value.id,
            action: "link",
          });
        });
      }
    }
    DevicesService.SetDeviceStateHistory({
      device_state_history_id:
        stateHistory?.device_state_history_id !== ""
          ? stateHistory?.device_state_history_id
          : "",
      serial: stateHistory?.serial !== "" ? stateHistory?.serial : deviceSerial,
      state_type: type,
      state_start: fromValue,
      state_location_id: locationId,
      state_description: description,
      state_result: result,
      state_end: toValue ?? "",
      assigned_to_person_id: userId,

      device_state_tag_link_action_list: tagsArrayToAdd,
      apiKey,
    }).then((json) => {
      if (json.success === true && json.count > 0) {
        setSavingLoading(false);
        dispatch(
          showMessage({
            message: t("saved Successfully"), //text or html
            autoHideDuration: 10000, //ms
            anchorOrigin: {
              vertical: "top", //top bottom
              horizontal: "center", //left center right
            },
            variant: "success", //success error info warning null
          })
        );
        dispatch(setStateHistory(initialState));
        triggerToggleDrawer(false);
        refreshStateHistory();
        handleCloseSave();
      }
    });
  }

  function handleDelete() {
    setDeleteLoading(true);
    const apiKey = organziation?.api_key_list?.[0]?.key;
    DevicesService.DeleteDeviceStateHistory({
      device_state_history_id: stateHistory?.device_state_history_id,
      apiKey,
    }).then((json) => {
      if (json.success === true && json.count > 0) {
        console.log(json);
        setDeleteLoading(false);
        dispatch(
          showMessage({
            message: t("Deleted Successfully"),
            autoHideDuration: 10000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
            variant: "success",
          })
        );
        dispatch(setStateHistory(initialState));
        triggerToggleDrawer(false);
        refreshStateHistory();
        handleCloseDelete();
      }
    });
  }

  function changeLocationValue(item) {
    setlocationId(item.operation_location_named_lookup_id);
  }
  function changeUserValue(item) {
    setUserId(item.profile_uid);
  }
  function changeTypeValue(name) {
    setType(name);
  }
  function handleChangeTags(item) {
    const newSelectedArray = [];

    for (let index = 0; index < selectedTags.length; index++) {
      newSelectedArray.push(selectedTags[index]);
    }
    const oldObjectIndex = newSelectedArray.map((e) => e.id).indexOf(item.id);

    console.log("oldObjectIndex", oldObjectIndex);
    if (oldObjectIndex > -1) {
      newSelectedArray.splice(oldObjectIndex, 1);
    } else {
      newSelectedArray.push(item);
    }
    setSelectedTags(newSelectedArray);
  }
  const handleClose = () => {
    setOpenDialog(false);
  };
  function handleOpenDialog() {
    setOpenDialog(true);
  }
  const handleCloseSave = () => {
    setOpenSaveDialog(false);
  };
  function handleOpenSaveDialog() {
    setOpenSaveDialog(true);
  }
  const handleCloseDelete = () => {
    setOpenDeleteDialog(false);
  };
  function handleOpenDeleteDialog() {
    setOpenDeleteDialog(true);
  }
  function handleConfirmClear() {
    // console.log("handlesavescheduletime");
    setClearLoading(true);
    setType("Unplanned");
    setResult("");
    setDescription("");
    setlocationId("");
    setUserId("");
    const oldTagsArray = [];
    setSelectedTags(oldTagsArray);
    setUserId("");
    setFromValue(dayjs(new Date()));
    setToValue(null);
    setClearLoading(false);
  }
  return (
    <>
      <DrawerHeader>
        <Typography
          sx={{
            fontSize: "35px",
            mb: 0,
            ml: 1,
            color: theme.palette.custom.text,
          }}
          variant="h2"
          gutterBottom
        >
          {t("NewStateHistory")}
        </Typography>
        <CloseIcon onClick={() => triggerToggleDrawer(false)} />
      </DrawerHeader>
      <Divider />
      <Box
        sx={{
          display: { xs: "block", sm: "grid" },
          gridTemplateColumns: `repeat(${2}, minmax(0, 1fr))`,
          width: "100%",
          gap: "1rem",
          color: "#FFFFFF",
          justifyContent: "stretch",
        }}
      >
        {/* <CustomTextField
          error={!type}
          value={type}
          onChange={(e) => {
            setType(e.target.value);
          }}
          id="txtType"
          label={t("Type")}
          variant="filled"
        /> */}
        <StateHistoryTypeMenu typeName={type} onChooseType={changeTypeValue} />
        <CustomTextField
          error={!description}
          value={description}
          onChange={(e) => {
            setDescription(e.target.value);
          }}
          multiline
          id="txtDescription"
          label={t("Description")}
          variant="filled"
        />
        <FormControl fullWidth>
          <FormLabel sx={{ ml: 1 }}>{t("startDate")}</FormLabel>
          <StyledDateTimePicker
            //  label={t("Date")}
            slotProps={{
              textField: { size: "small" },
              day: {
                sx: {
                  "&.MuiPickersDay-root.Mui-selected": {
                    backgroundColor: theme.palette.custom.buttonColor,
                    borderColor: theme.palette.custom.borderColor,
                    borderRadius: "4px",
                  },
                },
              },
              layout: {
                sx: {
                  ".MuiDateCalendar-root": {
                    color: theme.palette.custom.borderColor,
                    borderWidth: 1,
                    borderColor: theme.palette.custom.borderColor,
                    border: "2px solid",
                    backgroundColor: theme.palette.custom.backgroundColor,
                  },
                  ".MuiPickersDay-root": {
                    color: theme.palette.custom.text,
                    borderColor: theme.palette.custom.borderColor,
                    borderRadius: "4px",
                  },
                  ".Mui-selected": {
                    borderColor: theme.palette.custom.borderColor,
                    border: "2px solid",
                  },
                  ".MuiPickersCalendarHeader-root": {
                    color: theme.palette.custom.text,
                  },
                  ".MuiPickersCalendarHeader-switchViewButton": {
                    color: theme.palette.custom.text,
                  },
                  ".MuiDayCalendar-weekDayLabel": {
                    color: theme.palette.custom.text,
                  },
                },
              },
            }}
            value={fromValue}
            onChange={(newValue) => setFromValue(newValue)}
            TextFieldComponent={(params) => (
              <TextField
                sx={{
                  height: "20px",
                  backgroundColor: theme.palette.custom.text,
                  borderColor: theme.palette.custom.borderColor,
                  color: theme.palette.custom.text,
                }}
                fullWidth
                // defaultValue={from}
                {...params}
              />
            )}
          />
        </FormControl>
        <FormControl fullWidth>
          <FormLabel sx={{ ml: 1 }}>{t("endDate")}</FormLabel>
          <StyledDateTimePicker
            // label={t("EndDate")}
            inputProps={{ "aria-label": "Without label" }}
            slotProps={{
              textField: { size: "small" },
              day: {
                sx: {
                  "&.MuiPickersDay-root.Mui-selected": {
                    backgroundColor: theme.palette.custom.buttonColor,
                    borderColor: theme.palette.custom.borderColor,
                    borderRadius: "4px",
                  },
                },
              },
              layout: {
                sx: {
                  ".MuiDateCalendar-root": {
                    color: theme.palette.custom.borderColor,
                    borderWidth: 1,
                    borderColor: theme.palette.custom.borderColor,
                    border: "2px solid",
                    backgroundColor: theme.palette.custom.backgroundColor,
                  },
                  ".MuiPickersDay-root": {
                    color: theme.palette.custom.text,
                    borderColor: theme.palette.custom.borderColor,
                    borderRadius: "4px",
                  },
                  ".Mui-selected": {
                    borderColor: theme.palette.custom.borderColor,
                    border: "2px solid",
                  },
                  ".MuiPickersCalendarHeader-root": {
                    color: theme.palette.custom.text,
                  },
                  ".MuiPickersCalendarHeader-switchViewButton": {
                    color: theme.palette.custom.text,
                  },
                  ".MuiDayCalendar-weekDayLabel": {
                    color: theme.palette.custom.text,
                  },
                },
              },
            }}
            value={toValue}
            onChange={(newValue) => setToValue(newValue)}
            TextFieldComponent={(params) => (
              <TextField
                sx={{
                  height: "20px",
                  backgroundColor: theme.palette.custom.text,
                  borderColor: theme.palette.custom.borderColor,
                  color: theme.palette.custom.text,
                }}
                fullWidth
                // defaultValue={"EndDate"}
                {...params}
              />
            )}
          />
        </FormControl>
        <CustomTextField
          error={!result}
          value={result}
          onChange={(e) => {
            setResult(e.target.value);
          }}
          id="txtResult"
          label={t("Result")}
          variant="filled"
        />
        <LocationsMenu
          locationName={locationId}
          onChooseLocation={changeLocationValue}
          locationsList={locationsList}
        />
        <UsersMenu
          userId={userId}
          onChooseUser={changeUserValue}
          usersList={usersList}
        />
        <MultiSelect
          label={t("Tags")}
          menuItems={tagsList}
          onChange={handleChangeTags}
          selectedValues={selectedTags}
        />
      </Box>
      <Box
        sx={{
          display: { xs: "block", sm: "flex" },
          flexDirection: "row",
          justifyContent: "flex-end",
          width: "100%",
          alignItems: "center",
          mt: "10px",
        }}
      >
        <StyledButton
          id="save"
          className="btn-primary btn"
          sx={{ float: "left", marginRight: "5px" }}
          onClick={handleOpenDialog}
          disabled={stateHistory?.device_state_history_id !== ""}
        >
          {t("Clear")}
        </StyledButton>
        <StyledButton
          id="delete"
          className="btn-primary btn"
          sx={{ float: "left", marginRight: "5px" }}
          onClick={handleOpenDeleteDialog}
        >
          {t("Delete")}
        </StyledButton>
        <StyledButton
          id="save"
          className="btn-primary btn"
          sx={{ float: "left", marginRight: "5px" }}
          disabled={!canBeSubmitted()}
          onClick={handleOpenSaveDialog}
        >
          {t("Save")}
        </StyledButton>
      </Box>
      <AlertDialog
        open={openDialog}
        onClose={handleClose}
        onDoFunction={handleConfirmClear}
        saveLoading={clearLoading}
        dialogTitle={t("AlertClear")}
        cancelLabel={t("Cancel")}
        buttonLabel={t("Clear")}
      />
      <AlertDialog
        open={openSaveDialog}
        onClose={handleCloseSave}
        onDoFunction={handleSave}
        saveLoading={savingLoading}
        dialogTitle={t("AlertSave")}
        cancelLabel={t("Cancel")}
        buttonLabel={t("Save")}
      />
      <AlertDialog
        open={openDeleteDialog}
        onClose={handleCloseDelete}
        onDoFunction={handleDelete}
        saveLoading={deleteLoading}
        dialogTitle={t("AlertDelete")}
        cancelLabel={t("Cancel")}
        buttonLabel={t("Delete")}
      />
    </>
  );
}
AddEditDeviceStateHistory.propTypes = {
  triggerToggleDrawer: PropTypes.func,
  refreshStateHistory: PropTypes.func,
  usersList: PropTypes.array,
  locationsList: PropTypes.array,
  tagsList: PropTypes.array,
};

export default AddEditDeviceStateHistory;
